import * as types from 'constants/action_types'

import graphql from 'api/graphql'

import { oauthTokenSelector } from 'selectors/app'
import { selectIsMerging } from 'selectors/page'
import {
  selectSnippetsById,
  selectMergeSnippetsVisibility,
} from 'selectors/tickets'

import { difference } from 'util/arrays'
import debug from 'util/debug'

function doFetchSnippets(ticketIds) {
  return (dispatch, getState) => {
    if (!ticketIds) return Promise.resolve(null)

    dispatch({
      type: types.FETCH_TICKET_SNIPPETS_REQUEST,
      data: {
        ticketIds,
      },
    })

    const state = getState()
    // TODO (jscheel): Create a proper query with variables.
    const query = `
      query SnippetsQuery {
        lastComments(ticketIds: [${ticketIds.map(id => `"${id}"`).join(',')}]) {
          ticketId
          body
        }
      }
    `
    const token = oauthTokenSelector(state)

    return graphql(token, query)
      .then(res => {
        const { lastComments } = res.json.data
        dispatch({
          type: types.FETCH_TICKET_SNIPPETS_SUCCESS,
          data: {
            ticketIds,
            lastComments,
          },
        })
      })
      .catch(err => {
        debug(err)
        dispatch({
          type: types.FETCH_TICKET_SNIPPETS_FAIL,
          data: {
            ticketIds,
            err,
          },
        })
      })
  }
}

export function doFetchMergeSnippets(tickets) {
  return (dispatch, getState) => {
    const state = getState()
    const showSnippets = selectMergeSnippetsVisibility(state)
    const isMerging = selectIsMerging(state)
    if (showSnippets && isMerging) {
      return dispatch(doFetchSnippets(tickets.map(t => t.id)))
    }
    return Promise.resolve()
  }
}

export function doUpdateMergeSnippetsVisibility(visible, ticketIds) {
  return (dispatch, getState) => {
    const state = getState()
    if (visible) {
      const snippetsById = selectSnippetsById(state)
      const newTicketIds = difference(ticketIds, Object.keys(snippetsById))
      dispatch({
        type: types.UPDATE_MERGE_SNIPPETS_VISIBILITY,
        data: { visible },
      })
      if (newTicketIds.length > 0) {
        return dispatch(doFetchSnippets(newTicketIds))
      }
    } else {
      return dispatch({
        type: types.UPDATE_MERGE_SNIPPETS_VISIBILITY,
        data: { visible },
      })
    }
    return false
  }
}
